import { ColorValues } from '@banhala/ui-kit';
import type { ColorValue } from 'react-native';
import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

export const InlineTodayDeliveryIcon = ({
  color = ColorValues.lilac40,
}: {
  color?: ColorValue;
}) => (
  <Svg width={48} height={18} viewBox="0 0 64 24" fill="none">
    <G clipPath="url(#inline_today_delivery_icon_clip)">
      <Path
        d="M39.0268 5.96698H34.6378L34.1993 7.60326H38.2957C37.3755 8.45115 35.4513 8.79328 33.6797 8.85278L33.2413 10.4891C35.4634 10.4147 37.6267 10.0428 39.2922 8.94203C40.357 9.96842 42.3204 10.3998 44.5141 10.4891L44.9525 8.85278C43.2631 8.7784 41.5301 8.40652 41.0215 7.60326H45.1333L45.5718 5.96698H41.1366L41.4315 4.86621H39.3217L39.0268 5.96698Z"
        fill={color}
      />
      <Path
        d="M37.3078 12.4972L37.1324 13.1517H32.7126L32.2861 14.7434H41.1103L40.9469 15.3533H32.1227L31.1063 19.1465H42.3638L42.7942 17.5399H33.6466L33.81 16.93H42.6342L43.6466 13.1517H39.2114L39.3868 12.4972H44.7152L45.1616 10.8312H32.4412L31.9948 12.4972H37.3078Z"
        fill={color}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.7179 5.50588L52.2755 7.15704H49.3649L49.8073 5.50588H47.7437L46.0178 11.9469H53.0556L54.7815 5.50588H52.7179ZM48.9225 8.80819H51.833L51.4345 10.2957H48.5239L48.9225 8.80819Z"
        fill={color}
      />
      <Path
        d="M60.3186 7.94543H58.3628L59.0603 5.34226H56.9505L55.133 12.1254H57.2428L57.8845 9.73046H59.8403L60.3186 7.94543Z"
        fill={color}
      />
      <Path
        d="M55.9733 17.4953H47.3955L47.5908 16.7665H55.9992L57.0714 12.765H46.5532L46.1148 14.4013H54.5232L54.3239 15.1451H45.9155L44.8433 19.1465H55.5309L55.9733 17.4953Z"
        fill={color}
      />
      <Path
        d="M22.6739 7.73712H31.5905L31.1321 9.44778H20.1057L21.1859 5.41658H23.2957L22.6739 7.73712Z"
        fill={color}
      />
      <Path
        d="M18.9813 10.3105H31.7017L31.2474 12.0063H18.527L18.9813 10.3105Z"
        fill={color}
      />
      <Path
        d="M20.0592 17.4953H29.2068L28.7644 19.1464H17.507L18.5752 15.1599H27.3994L27.5827 14.4756H18.7585L19.1969 12.8393H30.1309L29.0747 16.7813H20.2505L20.0592 17.4953Z"
        fill={color}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6182 12.5717C16.6947 11.8875 17.4814 10.9057 17.8321 9.59669C18.1869 8.2728 17.9224 7.30591 17.2125 6.62164C16.3805 5.81838 14.9134 5.43162 13.0654 5.43162C11.2174 5.43162 9.55834 5.81838 8.2805 6.62164C7.20395 7.30591 6.42128 8.2728 6.06654 9.59669C5.71579 10.9057 5.97632 11.8875 6.68618 12.5717C7.37719 13.2114 8.44794 13.5833 9.81746 13.7023L9.03225 16.6327H3.76545L3.29114 18.4028H15.8575L16.3319 16.6327H11.1266L11.9119 13.7023C13.3297 13.5833 14.5998 13.2114 15.6182 12.5717ZM15.3908 7.96042C15.7799 8.34717 15.9176 8.86781 15.7223 9.59669C15.531 10.3107 15.1143 10.8313 14.5179 11.2181C13.7008 11.7387 12.563 11.9619 11.3156 11.9619C10.0682 11.9619 9.04998 11.7387 8.51189 11.2181C8.12272 10.8313 7.98502 10.3107 8.17634 9.59669C8.37164 8.86781 8.78835 8.34717 9.38478 7.96042C10.2019 7.43978 11.3397 7.21665 12.5871 7.21665C13.8345 7.21665 14.8527 7.43978 15.3908 7.96042Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="inline_today_delivery_icon_clip">
        <Rect width={58.0462} height={15.4} fill="white" x={3} y={4.2998} />
      </ClipPath>
    </Defs>
  </Svg>
);
